import { BaseApi } from "../../shared/api/base";

export class BaseDecisionTreeViewerApi extends BaseApi {
  constructor(options) {
    super({ api: "decision_tree", ...options });
  }
}
